function getEnvVariable<T extends string | number | boolean = string>(key: string): T | undefined {
  return (window._env_[key] ?? import.meta.env[`VITE_${key}`]) as T;
}

function getRequiredEnvVariable<T extends string | number | boolean = string>(key: string): T {
  const value = window._env_[key] ?? import.meta.env[`VITE_${key}`];

  if (typeof value === 'undefined') {
    console.error(key);
    throw new Error('env variable is not set');
  }

  return value as T;
}

export const DASHBOARD_SERVICE_PREFIX_DIRECTORY = '/service';
export const DASHBOARD_SERVICE_API_URL = DASHBOARD_SERVICE_PREFIX_DIRECTORY + '/v1';
export const SESSION_MANAGEMENT_SOCKET_URL = DASHBOARD_SERVICE_PREFIX_DIRECTORY + '/secured/session-management';
export const API_GOSTORAGE_URL = DASHBOARD_SERVICE_PREFIX_DIRECTORY + '/v1';
export const WELL_DIRECTORY_SERVICE_PREFIX_DIRECTORY = '/well-directory-service';
export const WELL_DIRECTORY_SERVICE_API_URL = WELL_DIRECTORY_SERVICE_PREFIX_DIRECTORY + '/api/v2';
export const WELL_STATUS_SOCKET_URL = WELL_DIRECTORY_SERVICE_PREFIX_DIRECTORY + '/ws';
export const OPERATION_MANAGEMENT_SERVICE_PREFIX_DIRECTORY = '/operation-management-service';
export const API_USER_FILES_URL = OPERATION_MANAGEMENT_SERVICE_PREFIX_DIRECTORY + '/api';
export const API_WEBSOCKET_OPERATIONS_PATH = OPERATION_MANAGEMENT_SERVICE_PREFIX_DIRECTORY + '/ws';
export const CACHE_SERVICE_PREFIX_DIRECTORY = '/cache';
export const API_LEGACY_CACHE_URL = CACHE_SERVICE_PREFIX_DIRECTORY + '/api/v1';
export const NOTIFICATIONS_SERVICE_PREFIX_DIRECTORY = '/notifications/api/v1';
export const API_WEBSOCKET_CACHE_PATH = CACHE_SERVICE_PREFIX_DIRECTORY + '/api/ws';

export const AUTH_API_URL = getRequiredEnvVariable('AUTH_API_URL') ?? '';
export const LIBRARIES_URL = getEnvVariable('DEVELOP_LIBRARIES_URL') ?? '';
export const IS_REPORT_AVAILABLE = getEnvVariable('IS_REPORT_AVAILABLE') === 'true' ? true : false;
// export const WELL_DETAILS_AVAILABLE = getEnvVariable('WELL_DETAILS_AVAILABLE') === 'true' ? true : false;
export const WELL_DETAILS_AVAILABLE = false;
export const WELL_ANALYSE_AVAILABLE = getEnvVariable('WELL_ANALYSE_AVAILABLE') === 'true' ? true : false;
export const DAY_DEPTH_AVAILABLE = getEnvVariable('DAY_DEPTH_AVAILABLE') === 'true' ? true : false;
export const WELL_LOGS_MANAGER_AVAILABLE = getEnvVariable('WELL_LOGS_MANAGER_AVAILABLE') === 'true' ? true : false;
export const IMAGE_BROADCAST_AVAILABLE = getEnvVariable('IMAGE_BROADCAST_AVAILABLE') === 'true' ? true : false;
export const OPERATIONAL_PARAMETERS_AVAILABLE =
  getEnvVariable('OPERATIONAL_PARAMETERS_AVAILABLE') === 'true' ? true : false;
export const DIRECTIONAL_DRILLING_AVAILABLE =
  getEnvVariable('DIRECTIONAL_DRILLING_AVAILABLE') === 'true' ? true : false;
export const OPERATIONS_LOG_TRACK_AVAILABLE =
  getEnvVariable('OPERATIONS_LOG_TRACK_AVAILABLE') === 'true' ? true : false;
export const EXPORT_CSV_AVAILABLE = getEnvVariable('EXPORT_CSV_AVAILABLE') === 'true' ? true : false;
export const VIDEOBROADCAST_AVAILABLE = getEnvVariable('VIDEO_BROADCAST_AVAILABLE') === 'true' ? true : false;
export const DEV_SETTINGS_PAGE_AVAILABLE = getEnvVariable('DEV_SETTINGS_PAGE_AVAILABLE') === 'true' ? true : false;
export const SPLIT_RANGE_TIME_IN_SECONDS = getEnvVariable('SPLIT_RANGE_TIME_IN_SECONDS') || 15;
export const SPLIT_RANGE_DEPTH = getEnvVariable('SPLIT_RANGE_DEPTH') || 5;
export const SHOW_GO_REPORT_CHARTS = getEnvVariable('SHOW_GO_REPORT_CHARTS') === 'true' ? true : false;
export const GO_REPORT_API_URL = getEnvVariable('GO_REPORT_API_URL') || undefined;
export const HEATMAP_AVAILABLE = getEnvVariable('HEATMAP_AVAILABLE') === 'true' ? true : false;
export const DRILLING_MULTI_ANALYSIS_AVAILABLE =
  getEnvVariable('DRILLING_MULTI_ANALYSIS_AVAILABLE') === 'true' ? true : false;
